// extracted by mini-css-extract-plugin
export var article = "article-styles-module--article--000b9";
export var articleWrapper = "article-styles-module--article-wrapper--bc8cb";
export var bigText = "article-styles-module--big-text--c4d7c";
export var image = "article-styles-module--image--59fa5";
export var richText = "article-styles-module--rich-text--caff8";
export var text = "article-styles-module--text--72c3a";